import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import {
  PublishWorkflowApiArg,
  PublishWorkflowApiResponse,
} from '../../types/k2/workflows';

type Request = {
  workflowId: string;
  version: number;
};

type ServerRequest = PublishWorkflowApiArg;
type ServerResponse = PublishWorkflowApiResponse;

export const publishWorkflowK2 = async (
  request: Request,
  options: ServiceRequestConfig = {},
) => {
  const params = mapParams(request);

  const serverResponse: ServerResponse = await k2.patch(
    `/workflows/${request.workflowId}/publish`,
    params.publishWorkflowRequest,
    { showErrorToast: true, ...options },
  );

  return mapResponse(serverResponse);
};

const mapParams = (request: Request): ServerRequest => {
  return {
    workflowId: request.workflowId,
    publishWorkflowRequest: {
      data: {
        type: 'workflows',
        attributes: {
          version: request.version,
        },
      },
    },
  };
};

const mapResponse = (serverResponse: ServerResponse) => {
  if (serverResponse === null) {
    return null;
  }

  return { id: serverResponse.data.id, ...serverResponse.data.attributes };
};
